module.exports = __webpack_public_path__ + "static/media/mail_icon.7827b276.svg";